import React, { PureComponent } from "react";
import { Form, Image } from "react-bootstrap";
import Select from "react-select";
import { get, filter } from "lodash";
import { onlyForCostNumbers, onlyNumbers } from "../../validation";
import DisplayByPermission from "../../component/DisplayByPermission";
import { isValidArray } from "../../helper";
import IconPlus from "../../assets/icon-plus.svg";
import { getDistrictCircle } from "../../services/apiServices";
import request from "../../services/requestService";
import { Loader } from "../../component";
import { LoaderPage } from "../../component/Loader";
//import { Form, Button, Container, Row, Col, Image } from "react-bootstrap";

export class CreateProjectCircle extends PureComponent {
  state = {
    addLocation: [{}],
    error: [{}],
    costError: null,
    circleData: [],
    districtPayloadId: [],
    circleSelectedValue: "",
    isLoading: false
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const {
      locations,
      resetForm,
      projectCost,
      updateParentStateError
    } = nextProps;

    const { locations: oldLocations, projectCost: oldProjectCost } = this.props;
    const { addLocation, error } = this.state;
    if (locations == oldLocations) {
      locations.forEach((value, index) => {
        addLocation[index] = value;
        error[index] = { error: false, message: "" };
      });

      this.setState({
        addLocation: [...addLocation],
        error: [...error]
      });
    }

    if (oldProjectCost !== projectCost) {
      const costError = this.isCostMoreThanProjectCost(
        projectCost,
        addLocation
      );
      updateParentStateError("costError", costError);
      this.setState({
        addLocation: [...addLocation],
        error: [...error],
        costError
      });
    }

    if (resetForm) {
      this.setState({
        addLocation: [{}],
        error: [{}]
      });
    }
  }

  onRemoveLocations = index => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost
    } = this.props;
    this.setState(prevState => {
      prevState.addLocation.splice(index, 1);
      prevState.error.splice(index, 1);
      const costError = this.isCostMoreThanProjectCost(
        projectCost,
        prevState.addLocation
      );
      updateParentState("locations", prevState.addLocation);
      updateParentStateError("locations", prevState.error);
      updateParentStateError("costError", costError);
      return {
        addLocation: [...prevState.addLocation],
        error: [...prevState.error],
        costError: costError
      };
    });
  };

  onAddLocations = () => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost
    } = this.props;
    this.setState(
      prevState => {
        const costError = this.isCostMoreThanProjectCost(
          projectCost,
          prevState.addLocation
        );
        return {
          addLocation: [...prevState.addLocation, {}],
          error: [{}, ...prevState.error],
          costError: costError
        };
      },
      () => {
        updateParentState("locations", this.state.addLocation);
        updateParentStateError("locations", this.state.error);
        updateParentStateError("costError", this.state.costError);
      }
    );
  };

  onChange = (
    value,
    key,
    mainKey,
    index,
    districtOptions,
    circleOptions,
    actionMeta
  ) => {
    const {
      updateParentState,
      updateParentStateError,
      projectCost,
      isEdit,
      getDistrictListForLocation,
      onDistricterrorChange,
      onStateerrorChange,
      previewData,
      getCircleListForLocation,
      status
    } = this.props;
    if (key === "districtId") {
      value = value && value.length && value.map(item => item.id);
      onDistricterrorChange(false);
    }
    if (key === "circleId") {
      value = value && value.length && value.map(item => item.id);
    }
    this.setState(prevState => {
      const data = {
        ...prevState.addLocation[index],
        [key]:
          key === "distance" || key === "cost"
            ? (key === "cost" && onlyForCostNumbers(value)) ||
              onlyNumbers(value)
            : value
      };
      if (key === "districtId") {
        data["circleList"] = this.state.circleData;
        this.setState({ isLoading: false });
      }
      if (key === "id" && value == 776) {
        this.setState({ isLoading: true });
        onStateerrorChange(false);
        data["cost"] = "";
        data["distance"] = "";
        data["district"] = [];

        if (previewData == null && status != "DRAFT") {
          if (data["districtId"] == undefined && previewData != null) {
            const districtIds = [];
            for (const location of previewData.locations) {
              if (location.circleId && location.circleId.length > 0) {
                districtIds.push(location.districtId[0]);
              }
            }
          } else {
            data["circleList"] = this.state.circleData;
          }
        } else if (status == "DRAFT") {
          if (data["districtId"] == undefined && previewData == null) {
            getDistrictListForLocation(undefined, value).then(resp => {
              data["districtList"] = resp.data;
              this.setState({
                [value]: resp.data,
                isLoading: false
              });
            });
          } else {
            getCircleListForLocation(undefined, data["districtId"]).then(
              resp => {
                data["circleList"] = resp.data;
                this.setState({
                  [value]: resp.data,
                  isLoading: false
                });
              }
            );
          }
        } else {
          if (data["districtId"] == undefined && previewData != null) {
            const districtIds = [];
            for (const location of previewData.locations) {
              if (location.circleId && location.circleId.length > 0) {
                districtIds.push(location.districtId[0]);
              }
            }
            //console.log(districtIds)
          } else {
            getCircleListForLocation(undefined, data["districtId"]).then(
              resp => {
                data["circleList"] = resp.data;
                this.setState({
                  [value]: resp.data,
                  isLoading: false
                });
              }
            );
          }
        }

        getDistrictListForLocation(undefined, value).then(resp => {
          data["districtList"] = resp.data;
          this.setState({
            [value]: resp.data,
            isLoading: false
          });
        });
      }
      if (key === "id" && value != 776) {
        this.setState({ isLoading: true });
        onStateerrorChange(false);
        data["cost"] = "";
        data["distance"] = "";
        data["districtId"] = [];
        data["district"] = [];
        data["circle"] = [];
        data["circleId"] = [];
        data["circleList"] = [];
        getDistrictListForLocation(undefined, value).then(resp => {
          data["districtList"] = resp.data;
          this.setState({
            [value]: resp.data,
            isLoading: false
          });
        });
      }
      if (key === "districtId") {
        data.districtIdName = filter(districtOptions, function(o) {
          return value && value.length && value.includes(o.id);
        });
        //console.log(circleOptions);
      }
      if (key === "circleId" && isEdit) {
        data.circleIdName = filter(districtOptions, function(o) {
          return value && value.length && value.includes(o.id);
        });
      }
      if (key === "circleId" && !isEdit) {
        data.circleIdName = filter(districtOptions, function(o) {
          return value && value.length && value.includes(o.id);
        });
      }
      //console.log(data)
      prevState.addLocation[index] = data;
      const costValue = prevState.addLocation[index].cost;
      const distanceValue = prevState.addLocation[index].distance;
      if (key === "id" && (costValue || distanceValue)) {
        if (costValue || distanceValue) {
          prevState.error[index] = {
            error: !value,
            message: !value && "Field is required."
          };
        } else {
          prevState.error[index] = {
            error: false,
            message: ""
          };
        }
      } else {
        const id = prevState.addLocation[index].id;
        let err = !!(!id && !(costValue || distanceValue));
        let msg = !!(!id && !(costValue || distanceValue))
          ? "Field is required"
          : "";

        prevState.error[index] = {
          error: err,
          message: msg
        };
      }

      // if location cost is more than project cost then throw error
      prevState.costError = this.isCostMoreThanProjectCost(
        projectCost,
        prevState.addLocation
      );
      updateParentState("locations", prevState.addLocation);
      updateParentStateError("locations", prevState.error);
      updateParentStateError("costError", prevState.costError);
      return {
        addLocation: [...prevState.addLocation],
        error: [...prevState.error],
        costError: prevState.costError
      };
    });
  };

  sortedOptionsList = index => {
    const { addLocation } = this.state;
    const { options } = this.props;
    const clone = [...addLocation];
    clone.splice(index, 1);
    return (options || []).filter(value => {
      const isAvail = clone.find(loc => {
        return loc.id == value.id;
      });
      return !isAvail;
    });
  };

  isCostMoreThanProjectCost = (projectCost, addLocation) => {
    let cost = 0;
    addLocation.forEach(location => {
      location.cost && (cost += +location.cost);
    });
    return (
      (this.props.distance &&
        cost > projectCost && {
          error: true,
          message: "Cost is higher than Project Cost"
        }) || { error: false }
    );
  };
  // handleDistrictSelectChange = async (
  //   value,
  //   actionMeta,
  //   index,
  //   param,
  //   selectOptions,
  // ) => {
  //   this.setState({ isLoading: true });
  //   const { groupId } = this.props;
  //   let updatedParam = { ...param }; // Declare updatedParam outside the switch

  //   if (groupId == 78) {
  //     const ids = value.map(item => item.id);

  //     const response = await request(getDistrictCircle(ids));
  //     // console.log(response.data.data)
  //     // console.log(response.data)
  //     this.setState({ circleData: response.data.data });
  //   } else {
  //   }
  //   switch (actionMeta.action) {
  //     case "remove-value":
  //     case "pop-value":
  //       let removedValue = actionMeta.removedValue;
  //       updatedParam["circleId"] = [];
  //       //console.log(removedValue);
  //       if (removedValue.isFixed) {
  //         return;
  //       }
  //       break;
  //     case "clear":
  //       value = selectOptions.filter(option => option.isFixed);
  //       break;
  //   }

  //   // ... rest of your code using updatedParam
  //   console.log(updatedParam);
  //   this.onChange(
  //     value,
  //     "districtId",
  //     "locations",
  //     index,
  //     param.districtList,
  //     updatedParam.circleList,
  //     actionMeta.action,
  //     updatedParam
  //   );
  // };
  handleDistrictSelectChange = async (
    value,
    actionMeta,
    index,
    param,
    selectOptions
  ) => {
    this.setState({ isLoading: true });
    const { groupId } = this.props;
    if (groupId == 78) {
      const ids = value.map(item => item.id);

      const response = await request(getDistrictCircle(ids));
      // console.log(response.data.data)
      // console.log(response.data)
      this.setState({ circleData: response.data.data });
    } else {
    }
    switch (actionMeta.action) {
      case "remove-value":
      case "pop-value":
        let removedValue = actionMeta.removedValue;
        param["circleId"] = [];
        console.log(removedValue);
        if (removedValue.isFixed) {
          return;
        }
        break;
      case "clear":
        value = selectOptions.filter(option => option.isFixed);
        break;
    }

    // const updatedLocations = this.state.addLocation.map(location => {
    //   const updatedCircleList = location.circleList.filter(circle => {
    //     return !location.circleId.includes(circle.id);
    //   });
    //   return {
    //     ...location,
    //     circleList: updatedCircleList
    //   };
    // });
    // this.setState({ addLocation: updatedLocations });

    //console.log(param)
    // console.log(this.state.addLocation)
    this.onChange(
      value,
      "districtId",
      "locations",
      index,
      param.districtList,
      param.circleList,
      actionMeta.action
    );
  };
  handleCircleSelectChange = async (
    value,
    actionMeta,
    index,
    param,
    selectOptions
  ) => {
    //console.log(param);
    this.setState({ circleSelectedValue: value });
    switch (actionMeta.action) {
      case "remove-value":
      case "pop-value":
        let removedValue = actionMeta.removedValue;
        if (removedValue.isFixed) {
          return;
        }
        break;
      case "clear":
        value = selectOptions.filter(option => option.isFixed);
        break;
    }
    this.onChange(value, "circleId", "locations", index, param.circleList);
  };
  render() {
    const { addLocation, costError, isLoading } = this.state;
    const {
      options,
      locations,
      error,
      iigMappingdetails,
      originalLocations,
      iigProjectReferenceId,
      groupId,
      isEdit,
      previewData
    } = this.props;
    // console.log(originalLocations)
    const {
      disabled = {
        location: false,
        addMore: false,
        district: false
      }
    } = this.props;
    //console.log(addLocation);
    const template = addLocation.map((param, index) => {
      const optionsList = this.sortedOptionsList(index);
      const optionsTemplate = (optionsList || []).map(value => {
        return (
          <option data-test="location-item" key={value.id} value={value.id}>
            {value.name}
          </option>
        );
      });
      const value = locations[index] || param;
      //console.log(value);
      const state = value.name;
      const _districtOptionsForMulti = (param.districtList || []).map(item => {
        item.value = item.id;
        item.label = item.name;
        if (originalLocations) {
          let originalLocationState = originalLocations.find(
            location => location.name === state
          );
          if (
            originalLocationState !== undefined &&
            iigProjectReferenceId !== null
          ) {
            let originalLocationStateDistrictIds =
              typeof originalLocationState.districtId === "object"
                ? originalLocationState.districtId
                : [];
            item.isFixed = originalLocationStateDistrictIds.includes(item.id);
          }
        }
        return item;
      });
      const _circleOptionsForMulti = (param.circleList || []).map(item => {
        item.value = item.id;
        item.label = item.name;
        if (originalLocations) {
          let originalLocationState = originalLocations.find(
            location => location.name === state
          );
          if (
            originalLocationState !== undefined &&
            iigProjectReferenceId !== null
          ) {
            let originalLocationStateDistrictIds =
              typeof originalLocationState.circleId === "object"
                ? originalLocationState.circleId
                : [];
            item.isFixed = originalLocationStateDistrictIds.includes(item.id);
          }
        }
        return item;
      });
      let districtMapping = [];
      let circleMapping = [];
      let districtListMapping = [];
      if (iigProjectReferenceId !== null) {
        if (isValidArray(originalLocations) !== 0) {
          const locationValues = originalLocations[index];
          districtListMapping = locationValues.districtIdName;
          districtMapping = isValidArray(districtListMapping);
        }
      }
      let circleListMapping = [];
      if (iigProjectReferenceId !== null) {
        if (isValidArray(originalLocations) !== 0) {
          const locationValues = originalLocations[index];
          circleListMapping = locationValues.circleIdName;
          circleMapping = isValidArray(circleListMapping);
        }
      }
      const errorExtract = error && error[index];
      const selectedValue = options.find(selected => {
        return +value.id === +selected.id;
      });
      //console.log("Error",options)
      //console.log("Error",selectedValue)
      param.districtId =
        param.districtId && param.districtId.length < 1
          ? param.districtIdName &&
            param.districtIdName.length &&
            param.districtIdName.map(item => item.id)
          : param.districtId;
      //console.log(param.districtId)
      const _districtSelectedValue = filter(param.districtList, function(o) {
        return (
          param.districtId &&
          param.districtId.length &&
          param.districtId.includes(o.id)
        );
      });
      param.circleId =
        param.circleId && param.circleId.length < 1
          ? param.circleIdName &&
            param.circleIdName.length &&
            param.circleIdName.map(item => item.id)
          : param.circleId;

      //param.circleId =[]

      const _circleSelectedValue = filter(param.circleList, function(o) {
        return (
          param.circleId &&
          param.circleId.length &&
          param.circleId.includes(o.id)
        );
      });
      if (_circleSelectedValue.length == 0 && isEdit) {
        param.circleId = [];
        param.circleIdName = [];
      }
      let isDisabled = false;
      let isClearable = true;
      if (originalLocations && iigProjectReferenceId !== null) {
        let originalLocationState = originalLocations.find(
          location => location.name === state
        );
        if (originalLocationState !== undefined) {
          let originalLocationStateDistrictIds =
            originalLocationState.districtId;
          let stateDistrictOptionsIds = _districtOptionsForMulti.map(
            item => item.id
          );
          let stateDistrictMatchedIds = originalLocationStateDistrictIds.filter(
            id => stateDistrictOptionsIds.includes(id)
          );
          // if there are one or more districts and all districts are matched
          if (
            stateDistrictMatchedIds.length &&
            stateDistrictMatchedIds.length ===
              originalLocationStateDistrictIds.length
          ) {
            isClearable = false;
            isDisabled = true;
          }
        }
      }

      let iigMappingStateText = "";
      let iigMappingDistrictsText = "";
      if (iigMappingdetails.iigLocations) {
        let iigMappingLocationState = iigMappingdetails.iigLocations.find(
          location => location.state === state
        );
        if (iigMappingLocationState) {
          iigMappingStateText = iigMappingLocationState.state;
          let iigMappingLocationStateDistricts =
            iigMappingLocationState.districtList;
          iigMappingLocationStateDistricts = iigMappingLocationStateDistricts.filter(
            district => district
          ); // remove null values
          iigMappingDistrictsText = iigMappingLocationStateDistricts.join(", ");
        }
      }

      const districtSelectStyles = {
        multiValueLabel: (base, state) => {
          return state.data.isFixed ? { ...base, paddingRight: 6 } : base;
        },
        multiValueRemove: (base, state) => {
          return state.data.isFixed ? { ...base, display: "none" } : base;
        }
      };

      return (
        <React.Fragment>
          <div
            className="row"
            style={{
              display: isEdit ? "none" : null,
              marginBottom: addLocation.length > 1 ? 10 : null
            }}
          >
            <div className="col-md-4" style={{ minWidth: "36%" }}>
              <Form.Label
                data-test="label-location"
                //style={{ width: "inherit" }}
              >
                State
                <span className="required">*</span>
                {!disabled.addMore && optionsList.length ? (
                  index === 0 ? (
                    <></>
                  ) : (
                    <div
                      className="btn-icon delete-location"
                      style={{ position: "absolute", marginLeft: "-2em" }}
                      title="Delete"
                      onClick={() => {
                        this.onRemoveLocations(index);
                      }}
                    />
                  )
                ) : null}
                <Form.Control
                  data-test="location"
                  as="select"
                  key="location"
                  // style={{ width: groupId == 78 ? "107%" : "104%" }}
                  value={(selectedValue && selectedValue.id) || ""}
                  onChange={e => {
                    this.onChange(e.target.value, "id", "locations", index);
                  }}
                  //isInvalid={get(errorExtract, "error")}
                  isInvalid={param.id == "" || get(errorExtract, "error")}
                  disabled={
                    isValidArray(originalLocations) !== 0
                      ? disabled.location
                      : false
                  }
                >
                  <option data-test="location-item" value="">
                    - Select State -
                  </option>
                  {optionsTemplate}
                </Form.Control>
                {/* <Form.Control.Feedback type="invalid">
                  {get(errorExtract, "message")}
                </Form.Control.Feedback> */}
                {param.id == "" || get(errorExtract, "error") ? (
                  <div class="district-mandatory-text mt-2">
                    This field is required
                  </div>
                ) : null}
              </Form.Label>
            </div>
            <div
              className="col-md-4"
              style={{ maxWidth: "37%", marginLeft: "-3%" }}
            >
              <Form.Label
                data-test="label-location"
                //style={{ width: "inherit" }}
              >
                District
                <span
                  className="required"
                  style={{ display: groupId == 78 ? null : "none" }}
                >
                  *
                </span>
              </Form.Label>

              <div
                className={
                  param.districtId === 0
                    ? "district-name-error-dropdown"
                    : "location-name district-name-dropdown"
                }
                data-test="district-name"
                // style={{ width: groupId == 78 && !isEdit ? 277 : 255 }}
              >
                <Select
                  styles={districtSelectStyles}
                  defaultValue={_districtSelectedValue || []}
                  isMulti
                  name="districtId"
                  placeholder="- Select District -"
                  options={_districtOptionsForMulti}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(value, actionMeta) => {
                    this.handleDistrictSelectChange(
                      value,
                      actionMeta,
                      index,
                      param,
                      _districtOptionsForMulti
                    );
                  }}
                  value={_districtSelectedValue || []}
                  isClearable={isClearable}
                  isDisabled={isDisabled}
                />
                {iigProjectReferenceId !== null && (
                  <p className="remaining-char iig-sector-id">
                    <span>
                      District from IIG:&nbsp;
                      {iigMappingDistrictsText || "N/A"}
                    </span>
                  </p>
                )}
              </div>
              {param.districtId === 0 && (
                <div class="district-mandatory-text mt-2">
                  This field is required
                </div>
              )}
            </div>
            <div
              className="col-md-4"
              style={{ minWidth: "35.4%", marginLeft: "-2%" }}
            >
              <Form.Label
                data-test="label-location"
                //style={{ width: "inherit" }}
              >
                Circle{" "}
              </Form.Label>
              <div
                className="location-name district-name-dropdown"
                data-test="district-name"
              >
                <Select
                  styles={districtSelectStyles}
                  defaultValue={_circleSelectedValue || []}
                  isMulti
                  name="circleId"
                  placeholder="- Select Circle -"
                  options={_circleOptionsForMulti}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(value, actionMeta) => {
                    this.handleCircleSelectChange(
                      value,
                      actionMeta,
                      index,
                      param,
                      _circleOptionsForMulti
                    );
                  }}
                  value={_circleSelectedValue || []}
                  isClearable={isClearable}
                  isDisabled={isDisabled}
                />
              </div>
            </div>
          </div>
          <div
            className={`added-location-wrapper`}
            style={{ display: isEdit ? null : "none" }}
          >
            <div className="added-location-detail">
              <div className="location-name">
                <div className="row">
                  <div className={groupId == 78 ? "col-md-4" : "col-md-6"}>
                    <Form.Label
                      data-test="label-location"
                      style={{ width: "inherit" }}
                    >
                      State
                      <span className="required">*</span>
                      {!disabled.addMore && optionsList.length ? (
                        index === 0 ? (
                          <></>
                        ) : (
                          <div
                            className="btn-icon delete-location"
                            style={{ position: "absolute", marginLeft: "-2em" }}
                            title="Delete"
                            onClick={() => {
                              this.onRemoveLocations(index);
                            }}
                          />
                        )
                      ) : null}
                      <Form.Control
                        data-test="location"
                        as="select"
                        key="location"
                        style={{ width: groupId == 78 ? "107%" : "104%" }}
                        value={(selectedValue && selectedValue.id) || ""}
                        onChange={e => {
                          this.onChange(
                            e.target.value,
                            "id",
                            "locations",
                            index
                          );
                        }}
                        //isInvalid={get(errorExtract, "error")}
                        isInvalid={param.id == "" || get(errorExtract, "error")}
                        disabled={
                          isValidArray(originalLocations) !== 0
                            ? disabled.location
                            : false
                        }
                      >
                        <option data-test="location-item" value="">
                          - Select State -
                        </option>
                        {optionsTemplate}
                      </Form.Control>
                      {/* <Form.Control.Feedback type="invalid">
                        {get(errorExtract, "message")}
                      </Form.Control.Feedback> */}
                      {param.id == "" || get(errorExtract, "error") ? (
                        <div class="district-mandatory-text mt-2">
                          This field is required
                        </div>
                      ) : null}
                    </Form.Label>
                  </div>
                  <div className={groupId == 78 ? "col-md-4" : "col-md-6"}>
                    <Form.Label
                      data-test="label-location"
                      style={{ width: "inherit" }}
                    >
                      District
                      <span
                        className="required"
                        style={{ display: groupId == 78 ? null : "none" }}
                      >
                        *
                      </span>
                      <div
                        className={
                          param.districtId === 0
                            ? "district-name-error-dropdown"
                            : "location-name district-name-dropdown"
                        }
                        data-test="district-name"
                        style={{ width: groupId == 78 && !isEdit ? 277 : 255 }}
                      >
                        <Select
                          styles={districtSelectStyles}
                          defaultValue={_districtSelectedValue || []}
                          isMulti
                          name="districtId"
                          placeholder="- Select District -"
                          options={_districtOptionsForMulti}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(value, actionMeta) => {
                            this.handleDistrictSelectChange(
                              value,
                              actionMeta,
                              index,
                              param,
                              _districtOptionsForMulti
                            );
                          }}
                          value={_districtSelectedValue || []}
                          isClearable={isClearable}
                          isDisabled={isDisabled}
                        />
                        {iigProjectReferenceId !== null && (
                          <p className="remaining-char iig-sector-id">
                            <span>
                              District from IIG:&nbsp;
                              {iigMappingDistrictsText || "N/A"}
                            </span>
                          </p>
                        )}
                      </div>
                      {param.districtId === 0 && (
                        <div class="district-mandatory-text mt-2">
                          This field is required
                        </div>
                      )}
                    </Form.Label>
                  </div>
                  <div
                    className="col-md-4"
                    style={{ display: groupId == 78 ? null : "none" }}
                  >
                    <Form.Label
                      data-test="label-location"
                      style={{ width: "inherit" }}
                    >
                      Circle
                      <div
                        className="location-name district-name-dropdown"
                        data-test="district-name"
                      >
                        <Select
                          styles={districtSelectStyles}
                          defaultValue={_circleSelectedValue || []}
                          isMulti
                          name="circleId"
                          placeholder="- Select Circle -"
                          options={_circleOptionsForMulti}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(value, actionMeta) => {
                            this.handleCircleSelectChange(
                              value,
                              actionMeta,
                              index,
                              param,
                              _circleOptionsForMulti
                            );
                          }}
                          value={_circleSelectedValue || []}
                          isClearable={isClearable}
                          isDisabled={isDisabled}
                        />
                      </div>
                    </Form.Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <div className="added-location">{template}</div>
        <div
          class="add-files add-project-map-file mt-3"
          onClick={this.onAddLocations}
          style={{ width: 155 }}
        >
          <div class="d-flex" data-test="upload-project-map">
            <Image src={IconPlus} alt="Plus Icon" />
            <div class="add-file-text ml-2" style={{ marginTop: 2.5 }}>
              &nbsp;ADD MORE STATES
            </div>
          </div>
        </div>
        <DisplayByPermission display={get(costError, "error")}>
          <div className="location-cost-error">{get(costError, "message")}</div>
        </DisplayByPermission>
        <LoaderPage loading={isLoading} />
      </React.Fragment>
    );
  }
}

export default CreateProjectCircle;
